'use es6';

import { useEffect, useState, useRef } from 'react';
import { TABLE } from 'reporting-data/constants/chartTypes';
import { Metrics } from './Metrics';
import { PAGINATION_TRACKING_METRIC_NAME, SNOWFLAKE_REPORT_PAGINATION, PAGINATION_TRACKING_WAIT_TIME_MS, UE_REPORT_PAGINATION, CRM_REPORT_PAGINATION, OTHER_REPORT_PAGINATION } from '../constants/trackingMetrics';
import { isSupportedCrmObject } from 'reporting-data/crmObjects/utils';
import { UNIFIED_EVENTS } from 'reporting-data/constants/dataTypes';
import { ALLOWLISTED_HUBSPOT_DEFINED_CRM_OBJECTS } from 'reporting-data/crmObjects/utils';
export const usePaginationTracking = (report, maxPageNumber, currentRowLimit) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const metricsSent = useRef(false);
  const metricTimer = useRef(undefined);
  useEffect(() => {
    const isRelationalReport = () => {
      return report.has('reportDefinition');
    };
    const getReportVisualType = () => {
      return isRelationalReport() ? report.getIn(['reportDefinition', 'visual', 'type']) : report.getIn(['chartType']);
    };
    const getReportType = () => {
      const reportDataType = report.getIn(['config', 'dataType']);
      if (isRelationalReport()) {
        return SNOWFLAKE_REPORT_PAGINATION;
      } else if (reportDataType === UNIFIED_EVENTS) {
        return UE_REPORT_PAGINATION;
      } else {
        const crmObjectID = ALLOWLISTED_HUBSPOT_DEFINED_CRM_OBJECTS.get(reportDataType);
        return isSupportedCrmObject(crmObjectID || reportDataType) ? CRM_REPORT_PAGINATION : OTHER_REPORT_PAGINATION;
      }
    };
    const trackPageNavigation = () => {
      const chartType = getReportVisualType();
      if (chartType === TABLE) {
        const reportType = getReportType();
        const totalRowsViewed = maxPageNumber.current * currentRowLimit.current;

        //When a report is being loaded it can send log reports with 0 or 1 rows
        if (totalRowsViewed && totalRowsViewed > 1) {
          Metrics.timer(PAGINATION_TRACKING_METRIC_NAME, {
            'report-type': reportType
          }).update(totalRowsViewed);
        }
      }
      metricsSent.current = true;
    };
    if (!isLoaded) {
      setIsLoaded(true);
      metricTimer.current = setTimeout(trackPageNavigation, PAGINATION_TRACKING_WAIT_TIME_MS);
    }
    return () => {
      if (!metricsSent.current) {
        trackPageNavigation();
      }
      clearTimeout(metricTimer.current);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};